import { publicPostApi } from './index';

/**
 * Login with phone number + password. Resolves with the backend payload
 * ({ status, tokens, user }); rejects with an Error whose `.message` is the
 * backend `msg` and `.data` the full payload. Token storage is the `user`
 * localStorage key (see store/reducers/userSlice.js) — the single source the
 * api client reads (`user.tokens.access` / `user.tokens.refresh`).
 */
function loginBackend(username, password) {
    return publicPostApi('system/auth/login/', {
        phone_number: username,
        password: password,
    });
}

export { loginBackend };
